import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import InputWithState from './InputWithState'

const StyledInput = styled(InputWithState)`
    flex: 50%;

    textarea {
        width: 90%;
    }

    input {
        width: 90%;
    }

    @media (max-width: ${props => props.theme.responsive.small}) {
        flex: 100%;
        margin-bottom: 2em;
    }
`

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`

class SideBySideInputFields extends React.Component {
    render() {
        const {
            data,
            values,
            touched,
            errors,
            errorMessages,
            setFieldValue,
            setFieldTouched,
            siteMetadata,
        } = this.props

        return (
            <Wrapper>
                {data.inputFields.map( (sideBySideInputField, index) => {
                    return (
                        <StyledInput
                            key={index}
                            data={sideBySideInputField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            errorMessages={errorMessages}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            siteMetadata={siteMetadata}
                        />
                    )
                })}
            </Wrapper>
        )
    }
}

SideBySideInputFields.propTypes = {
    data: PropTypes.object,
    values: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    errorMessages: PropTypes.object,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    siteMetadata: PropTypes.object,
}

export default SideBySideInputFields
